'use strict';

const DEFAULT_MODAL_SELECTOR = '.geo-redirect-modal';
// Wait for both Tealium consent steps; #consent-tracking is the SFRA base fallback.
const COOKIE_CONSENT_SELECTOR = '#__tealiumGDPRecModal, #__tealiumGDPRcpPrefs, #consent-tracking';
const COOKIE_CONSENT_INTERACTION_COOKIE = 'CONSENTMGR';
const COOKIE_CONSENT_POLL_INTERVAL_MILLISECONDS = 200;
// utag.js injects the banner after DOMContentLoaded, so a missing banner at init does not mean the visitor answered it.
const COOKIE_CONSENT_APPEARANCE_TIMEOUT_MILLISECONDS = 8000;

module.exports = function initGeoRedirectModal() {
	function getModal() {
		return $(DEFAULT_MODAL_SELECTOR).first();
	}

	function cookieConsentVisible() {
		return $(COOKIE_CONSENT_SELECTOR).is(':visible');
	}

	// The consent manager writes this cookie only once the visitor has answered the banner.
	function cookieConsentAlreadyAnswered() {
		return new RegExp('(?:^|;\\s*)' + COOKIE_CONSENT_INTERACTION_COOKIE + '=').test(document.cookie);
	}

	// base consentTracking drops its modal with .remove(), so Bootstrap never clears backdrop and body state
	function releaseOrphanModalBackdrop() {
		if ($('.modal.show').length) {
			return;
		}
		$('.modal-backdrop').remove();
		$('body').removeClass('modal-open');
	}

	// no attempt cap once the banner is up: this waits for the visitor however long they take
	function onCookieConsentSettled(callback) {
		const startedAt = Date.now();
		let bannerSeen = false;

		const timer = setInterval(function waitForCookieConsentAnswer() {
			if (cookieConsentVisible()) {
				bannerSeen = true;
				return;
			}

			const bannerMayStillAppear =
				!bannerSeen &&
				!cookieConsentAlreadyAnswered() &&
				Date.now() - startedAt < COOKIE_CONSENT_APPEARANCE_TIMEOUT_MILLISECONDS;

			if (bannerMayStillAppear) {
				return;
			}

			clearInterval(timer);
			callback();
		}, COOKIE_CONSENT_POLL_INTERVAL_MILLISECONDS);
	}

	function show() {
		const $modal = getModal();
		if (!$modal.length || typeof $modal.modal !== 'function') {
			return false;
		}
		releaseOrphanModalBackdrop();
		$modal.modal('show');
		return true;
	}

	function hide() {
		const $modal = getModal();
		if (!$modal.length || typeof $modal.modal !== 'function') {
			return false;
		}
		$modal.modal('hide');
		return true;
	}

	window.lavazzaGeoRedirectModalShow = show;
	window.lavazzaGeoRedirectModalHide = hide;

	const $modal = getModal();

	if (!$modal.length || typeof $modal.modal !== 'function') {
		onCookieConsentSettled(releaseOrphanModalBackdrop);
		return;
	}

	let usingKeyboard = false;
	let focusSkipLinkOnClose = false;

	// Capture input before Bootstrap handles Escape or a dismissal click.
	document.addEventListener('keydown', function onGeoRedirectKeydown(event) {
		if (!event.altKey && !event.ctrlKey && !event.metaKey) {
			usingKeyboard = true;
		}
	}, true);

	document.addEventListener('pointerdown', function onGeoRedirectPointerdown() {
		usingKeyboard = false;
	}, true);

	// FE scope only: backend decides whether the modal should render / auto-open for this session.
	const autoOpen = String($modal.data('auto-open') || 'false') === 'true';

	function markShownForSession() {
		const markShownUrl = $modal.data('mark-shown-url');
		if (!markShownUrl) {
			return;
		}
		$.ajax({ url: markShownUrl, type: 'get', dataType: 'json' });
	}

	$modal.on('shown.bs.modal', function onGeoRedirectShown() {
		$('.modal-backdrop').last().addClass('geo-redirect-modal-backdrop');
		markShownForSession();
	});

	$modal.on('hide.bs.modal', function onGeoRedirectHide() {
		focusSkipLinkOnClose = usingKeyboard;
	});

	$modal.on('hidden.bs.modal', function onGeoRedirectHidden() {
		releaseOrphanModalBackdrop();

		if (!focusSkipLinkOnClose) {
			return;
		}

		const skipLink = document.querySelector('.skip-link');
		if (skipLink) {
			skipLink.focus();
		}
	});

	$modal.on('click', '[data-geo-redirect-action]', function onGeoRedirectAction() {
		const action = String($(this).data('geo-redirect-action') || '').trim();
		if (!action) {
			return;
		}

		// Hook for analytics / future integrations; redirect/session persistence stays server-driven.
		$modal.trigger('lvz:geoRedirectAction', { action: action });
	});

	onCookieConsentSettled(autoOpen ? show : releaseOrphanModalBackdrop);
};
